import type { AllowedRole } from '@/helpers/userSatisfiesRole';

export type RouteSpecial = 'all' | 'no-user' | 'restrict';
export type RouteAllowed = AllowedRole | RouteSpecial;

export type AccessPolicy = {
  allowed: RouteAllowed[];
  allowedConfig?: { module?: string };
};

export const access = {
  public: { allowed: ['all'] },
  guest: { allowed: ['no-user'] },
  user: { allowed: ['user'] },
  admin: { allowed: ['admin'] },
  salesAdmin: { allowed: ['salesAdmin'] },
  partner: { allowed: ['partner', 'salesAdmin'] },
  organisation: {
    allowed: ['restrict'],
    allowedConfig: { module: 'organisation' },
  },
  plainLanguage: {
    allowed: ['restrict'],
    allowedConfig: { module: 'plainLanguage' },
  },
  translate: {
    allowed: ['restrict'],
    allowedConfig: { module: 'translate' },
  },
  accessModule: {
    allowed: ['restrict'],
    allowedConfig: { module: 'access' },
  },
  supportTickets: {
    allowed: ['restrict'],
    allowedConfig: { module: 'supportTickets' },
  },
} satisfies Record<string, AccessPolicy>;
